import { render } from "./widget-employee.vue?vue&type=template&id=a7e52be6"
import script from "./widget-employee.vue?vue&type=script&setup=true&lang=js"
export * from "./widget-employee.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-card/widgets/widget-employee.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a7e52be6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a7e52be6', __exports__)) {
    api.reload('a7e52be6', __exports__)
  }
  
  module.hot.accept("./widget-employee.vue?vue&type=template&id=a7e52be6", () => {
    api.rerender('a7e52be6', render)
  })

}


export default __exports__